export const LOGIN_FORM_KEYS = {
    email: "email",
    phone_number: "phone_number",
    country_code: "country_code",
} as const;

export const PHONE_NUMBER_LENGTH = 10;
